import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrl: './alerta.component.scss',
  imports: [CommonModule, ButtonModule]
})
export class AlertaDialogComponent {
  @Input() title:string|null = '';
  @Input() message:string|null = '';
  @Input() type:string|null = '';
  @Input() show:boolean|null = false;
  @Input() decision:boolean|null = false;

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  constructor() {}

  getIconByType(): string {
    switch (this.type) {
      case 'success':
        return 'pi pi-check';
      case 'error':
        return 'pi pi-times';
      case 'info':
        return 'pi pi-info-circle';
      case 'warn':
        return 'pi pi-exclamation-triangle';
      default:
        return 'pi pi-info-circle';
    }
  }

  getVariantClass(): string {
    switch (this.type) {
      case 'success':
        return 'alert-hero--success';
      case 'error':
        return 'alert-hero--error';
      case 'info':
        return 'alert-hero--info';
      case 'warn':
        return 'alert-hero--warn';
      default:
        return 'alert-hero--info';
    }
  }

  getDefaultTitle(): string {
    switch (this.type) {
      case 'success':
        return 'Correcto';
      case 'error':
        return 'Error';
      case 'warn':
        return 'Alerta';
      case 'info':
        return 'Información';
      default:
        return 'Mensaje';
    }
  }
}
